import primaryComponents from "../../../primaryComponents";
import Validation from "./Validation";
import useTaxesAccountSettings from "./useTaxesAccountSettings";
import styles from "../../../../pages/appPages/Accounting/AccountSettings/styles.module.scss";

const TaxesAccountSettings = ({
  filterAccountBySubAccountType,
  findAccountMapping,
  updateAccountMappingMutation,
  handleAccountMappingSubmit,
}) => {
  const { taxesAccountMapping, setTaxesAccountMapping } =
    useTaxesAccountSettings(findAccountMapping);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = Validation({ taxesAccountMapping });
  return (
    <form className="p-3" onSubmit={handleSubmit(handleAccountMappingSubmit)}>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>VAT Payable Account</h5>
          <span>Account for VAT collected from customers</span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("vat_payable")}
            control={control}
            name="vat_payable_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("vat_payable_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setTaxesAccountMapping((prev) => ({
                ...prev,
                vat_payable_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.vat_payable_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>VAT Receivable Account</h5>
          <span>
            Asset account to track VAT paid on purchases (Input VAT) Recoverable
            from FIRS
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("vat_receivable")}
            control={control}
            name="vat_receivable_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("vat_receivable_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setTaxesAccountMapping((prev) => ({
                ...prev,
                vat_receivable_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.vat_receivable_account}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          type="submit"
          isDisabled={updateAccountMappingMutation.isLoading}
          isLoading={updateAccountMappingMutation.isLoading}
          loadingText={"Updating..."}
        >
          Save Changes
        </primaryComponents.Button>
      </div>
    </form>
  );
};
export default TaxesAccountSettings;
